import { render } from "./Exclamation.vue?vue&type=template&id=b35f9e8c"
const script = {}
script.render = render

export default script